import { bcp47, resolveLocale } from '@upme/i18n';

const SUFFIXES: Record<'ru' | 'en', { thousand: string; million: string }> = {
  ru: { thousand: 'к', million: 'м' },
  en: { thousand: 'k', million: 'm' },
};

/**
 * Компактное отображение «Энергии» (копия mini-app-версии — два независимых UI).
 * Меньше 1 000 — как есть; 1 000–999 999 — суффикс тысяч; от 1 000 000 — суффикс миллионов.
 * `locale` — сырой `i18n.language` вызывающего компонента; без него — фолбэк `resolveLocale(undefined)` = 'ru'.
 */
export function formatEnergy(value: number, locale?: string): string {
  if (!Number.isFinite(value)) return String(value);

  const sign = value < 0 ? '-' : '';
  const n = Math.floor(Math.abs(value));
  const suffix = SUFFIXES[resolveLocale(locale)];

  if (n < 1000) return `${sign}${n}`;
  if (n < 1_000_000) return `${sign}${Math.floor(n / 1000)}${suffix.thousand}`;
  return `${sign}${Math.floor(n / 1_000_000)}${suffix.million}`;
}

/** Полное число с разделителями тысяч. */
export function formatEnergyFull(value: number, locale?: string): string {
  if (!Number.isFinite(value)) return String(value);
  return new Intl.NumberFormat(bcp47(resolveLocale(locale))).format(Math.floor(value));
}

/** Дельта транзакции со знаком (+ / −) и тем же сокращением. */
export function formatEnergyDelta(delta: number, locale?: string): string {
  if (delta > 0) return `+${formatEnergy(delta, locale)}`;
  if (delta < 0) return `-${formatEnergy(Math.abs(delta), locale)}`;
  return formatEnergy(0, locale);
}
